import { useTranslation } from "react-i18next";

import type { BaseComponentProps } from "../types";

import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/components/ui/v2/alert";
import type { AlertSchemaProps, UiComponent } from "@/features/integrations/types";

type AlertComponentProps = BaseComponentProps & AlertSchemaProps;

export function AlertComponent({
  variant,
  visibleWhenDataKey,
  title,
  description,
  actions,
  data,
  renderChild,
}: AlertComponentProps) {
  const { t } = useTranslation();

  if (visibleWhenDataKey && !data?.[visibleWhenDataKey]) {
    return null;
  }

  const alertVariant =
    variant === "warning"
      ? "warning"
      : variant === "destructive"
        ? "destructive"
        : variant === "info"
          ? "info"
          : "default";

  const descriptionText = description?.dataKey
    ? (data?.[description.dataKey] as string) ?? (description.fallback ? t(description.fallback) : null)
    : description?.fallback
      ? t(description.fallback)
      : null;

  return (
    <Alert variant={alertVariant}>
      {title && <AlertTitle>{t(title)}</AlertTitle>}
      <AlertDescription className="flex items-center gap-3">
        {descriptionText && <span>{descriptionText}</span>}
        {actions?.map((action: UiComponent, index: number) => (
          <span key={`alert-action-${index}`}>{renderChild(action)}</span>
        ))}
      </AlertDescription>
    </Alert>
  );
}
